import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen w-full" }
const _hoisted_2 = { class: "flex justify-center h-screen overflow-auto" }
const _hoisted_3 = { class: "overflow-y-auto" }
const _hoisted_4 = { class: "flex flex-row py-6 rounded-md px-4 items-center justify-between w-full bg-pink-lp-200 mt-5" }
const _hoisted_5 = { class: "font-montserrat text-red-lp-100 text-14px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_TableV2, {
          class: "my-2",
          borderTop: false,
          isEmpty: !_ctx.stiSCList.length && !_ctx.isLoading,
          emptyMessage: _ctx.$t('stoSc.process.emptyStiScList'),
          columns: _ctx.columns,
          data: _ctx.stiSCList,
          errorCause: _ctx.errorCause,
          onTryAgain: _ctx.fetchSTISCList,
          loading: _ctx.isLoading,
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
          onRequest: _ctx.fetchSTISCList,
          checkedData: _ctx.checkedData,
          "onUpdate:checkedData": _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkedData = $event)),
          isCheckBox: "",
          paginationStyle: "v3",
          customContentHeadCheckbox: "",
          highlightData: _ctx.highlightedData
        }, _createSlots({ _: 2 }, [
          (_ctx.checkedData.length)
            ? {
                name: "contentHeadCheckbox",
                fn: _withCtx(() => [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("p", _hoisted_5, [
                      _createVNode("strong", null, _toDisplayString(_ctx.checkedData.length) + " " + _toDisplayString(_ctx.$t("stoSc.process.bulkBannerDataWord")), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("stoSc.process.bulkBannerMiddle")) + " ", 1),
                      _createVNode("strong", null, _toDisplayString(_ctx.$t("stoSc.process.bulkBannerStatusLabel")), 1)
                    ]),
                    _createVNode(_component_lp_button, {
                      onClick: _ctx.updateToSTOSC,
                      title: _ctx.$t('stoSc.process.buttonSubmit'),
                      textColor: "red-lp-100",
                      outline: ""
                    }, null, 8, ["onClick", "title"])
                  ])
                ])
              }
            : undefined
        ]), 1032, ["isEmpty", "emptyMessage", "columns", "data", "errorCause", "onTryAgain", "loading", "pagination", "onRequest", "checkedData", "highlightData"])
      ])
    ])
  ]))
}